export default __webpack_public_path__ + "static/media/EuclidSquare-SemiBold.1d008e5f.woff";